<template>
  <main id="main">
    <Loading :isProcessing="isProcessing"></Loading>
    <div class="l-contents">
      <h1 class="l-pageTitle">診断マスタ編集</h1>

      <div class="l-btn-createnew_pos">
        <div class="btn-create-new_wh"  @click="goDeleteList('')"><a>削除した診断項目一覧</a></div>
      </div>

      <div class="l-contentsBox">
        <div style="display: flex; justify-content: flex-end;">
          <div class="btn-basic is-inlne is-primary">
            <button v-if="!canDrag" @click="canDrag = true">並び順を変更する</button>
            <button v-if="canDrag" @click="fixSortOrder()">並び順を確定する</button>
          </div>
        </div>
        <table class="l-form-table">
          <caption>診断条マスタ</caption>
          <tbody>
            <tr>
              <td colspan="2">
                <button v-if="!canDrag" class="link-arrow" @click="goSectionNew()">新規追加</button>
              </td>
            </tr>
            <tr v-for="(diagSection, index) in diagSections"
                :key="diagSection.sectionId"
                :draggable="canDrag"
                @dragstart="dragIndex = index"
                @dragenter="changeSectionOrder(index)">
              <td v-if="!canDrag" style="width: 100px;">
                <button class="link-arrow" @click="goSectionEdit(diagSection.sectionId)">編集</button>
              </td>
              <td v-if="!canDrag">{{ diagSection.sortOrder }}</td>
              <td v-if="canDrag" style="cursor: pointer; width: 100px; padding-left: 1.2em;">三</td>
              <td v-if="canDrag">{{ index + 1 }}</td>
              <td :style="canDrag ? 'pointer-events: none;' : ''">
                {{ diagSection.sectionNm }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </main>
</template>

<script>
import Loading from '@/components/parts/common/Loading.vue';

export default {
  components: {
    Loading,
  },
  data() {
    return {
      isProcessing: false,
      diag: {
        verNo: '',
        verNm: '',
        fromDt: null,
        toDt: null,
        deleteFlg: false,
      },
      diagSections: [],
      canDrag: false,
      dragIndex: null,
    }
  },
  computed: {
    verId() {
      return this.$store.getters['master/getVerId'];
    },
  },
  created: function () {
    this.getDiag(this.verId);
  },
  methods: {
    async getDiag(verId) {
      this.isProcessing = true;
      let res = await this.$axios.post('/ld/api/master/diag/getDiagEdit', {
        verId: verId,
      });
      if (res) {
        this.diag = res.data.diag;
        this.diagSections = res.data.diagSections;
      }
      this.isProcessing = false;
    },
    goSectionEdit(sectionId) {
      this.$store.dispatch('master/setSectionId', sectionId);
      this.$router.push({ name: 'diag-section-master-edit' } );
    },
    goSectionNew() {
      this.$store.dispatch('master/setSectionId', null);
      this.$router.push({ name: 'diag-section-master-new' } );
    },

    goDeleteList() {

      this.$router.push({ name: 'diage-section-master-delete-list', params: {} });
    },

    changeSectionOrder(index) {
      if (index === this.dragIndex) return;
      const deleteElement = this.diagSections.splice(this.dragIndex, 1)[0];
      this.diagSections.splice(index, 0, deleteElement);
      this.dragIndex = index;
    },
    async fixSortOrder() {
      this.canDrag = false;

      this.diagSections = this.diagSections.map((ds, index) => {
        ds.sortOrder = index + 1;
        return ds;
      });

      this.isProcessing = true;
      const res = await this.$axios.post('/ld/api/master/diag/storeDiagSectionSortOrder', {
        diagSections: this.diagSections,
        verId: this.verId,
      });
      if (res.status === 200) {
        this.$toast.info('登録が完了しました');
      } else {
        this.$toast.error(res.data.message);
      }
      this.isProcessing = false;
    },
  },
}

</script>
